import React, { useState, useEffect, useMemo } from "react";
import { useTable, useGlobalFilter } from 'react-table';
import axios from "axios";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import DynamicForm from './DynamicForm';
import LoaderComponent from "../../../libraries/loader/loader";
import { Fetchexecutequery, Fetchheaderdata, Fetchupdatequery } from '../../../services/process/BRS1/brsService7';
import { CreateData } from '../../../services/process/process_data/process_data';
import { Icon } from 'semantic-ui-react';
import './reconSummary.css';
import Select from "react-select";
import EditIcon from '@mui/icons-material/Edit';
import excelIcon from '../../../assets/images/excel.png';

function PurchaseRequirement() {
  const [formData, setFormData] = useState({});
  const [formData_1, setFormData_1] = useState({});
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [formData1, setFormData1] = useState({});
  const [formData2, setFormData2] = useState({});
  const [formData3, setFormData3] = useState({});
  const [remarksData, setRemarksData] = useState('');
  const [rowData, setRowData] = useState([]);
  const [tablerowData, settableRowData] = useState([]);
  const [filterconditions,setFilterconditions] =  useState([{"is_active" : 1,"entity_id" : userCredentials.entities_id,"tenant_id": userCredentials.tenants_id,"group_id": userCredentials.groups_id}]);
  const [fields, setFields] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [columnDefs, setColumnDefs] = useState([]);
  const [tablecolumnDefs, settableColumnDefs] = useState([]);
  const [fields1, setFields1] = useState(null);
  const [columnDefs1, setColumnDefs1] = useState([]);
  const [fields2, setFields2] = useState(null);
  const [columnDefs2, setColumnDefs2] = useState([]);
  const [fields3, setFields3] = useState(null);
  const [columnDefs3, setColumnDefs3] = useState([]);
  const [fields4, setFields4] = useState(null);
  const [columnDefs4, setColumnDefs4] = useState([]);
  const [prfno, setPrfno] = useState('');
  const [section2Rows, setSection2Rows] = useState([{}]);
  const [section3Rows, setSection3Rows] = useState([{}]);
  const [unMatchedHidden, setUnMatchedHidden] = useState(false);
  const [createHidden, setCreateHidden] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editMode, setEditMode] = useState(false); // State to track if in edit mode
  const [quotations, setQuotations] = useState([{ id: 1, label: "Quotation 1" }]);
  const [selectedQuotationId, setSelectedQuotation] = useState(0);
  const [quotationData, setQuotationData] = useState([]);
  const [quotationinputData, setQuotationinputData] = useState([]);

  // State to control collapsibility of divs
  const [isDiv1Open, setIsDiv1Open] = useState(true);
  const [isDiv2Open, setIsDiv2Open] = useState(false);
  const [isDiv3Open, setIsDiv3Open] = useState(false);
  const [isDiv4Open, setIsDiv4Open] = useState(false);

  useEffect(() => {
    fetchFieldInfo(25, setFields1, setColumnDefs1);
    fetchFieldInfo(23, setFields2, setColumnDefs2);
    fetchFieldInfo(6, setFields3, setColumnDefs3);
    fetchFieldInfo(17, setFields4, setColumnDefs4);
    fetchprfTableInfo1();
    fetchtabledetailsInfo();
    console.log(userCredentials)
  }, []);

  useEffect(() => {
    if (selectedQuotationId !== null) {
      // Set formData2 with the data of the selected quotation from quotationData
      console.log("selectedQuotationId",selectedQuotationId,quotationData[selectedQuotationId])
      setFormData2(quotationData[selectedQuotationId] || {});
    }
  }, [selectedQuotationId]);

  useEffect(() => {
    if (selectedQuotationId !== null) {
      // Set formData2 with the data of the selected quotation from quotationData
      console.log("quotationinputData",selectedQuotationId,quotationinputData[selectedQuotationId])
      setSection3Rows(quotationinputData[selectedQuotationId] || [{}]);
    }
  }, [selectedQuotationId]);

    // Helper function to format date
  const getFormattedDate = () => {
    const currentDate = new Date();
    return currentDate.toISOString().slice(0, 19).replace("T", " ");
  };

  const enhanceRowsWithCommonFields = (rows, commonFields) =>
    rows.map(row => ({ ...row, ...commonFields }));

  // Helper function to create payload
  const createPayload = (database, table, formData) => ({
    database,
    table,
    formData,
  });

  // Helper function for Axios requests
  const makeApiRequest = (url, payload, headers) => {
    return axios.post(url, payload, headers)
      .then(response => {
        console.log("API Response:", response);
      })
      .catch(error => {
        console.error("API Error:", error);
        throw new Error("Error with API call");
      });
  };


useEffect(() => {
  if (fields && fields.length > 0) {
    console.log("fields are fetched",fields)
  }
}, [fields]);



  const addRowInSection3 = () => {
    setSection3Rows(prevRows => [...prevRows, {}]);
  };
    
  const addRowInSection2 = () => {
    setSection2Rows([...section2Rows, {}]);  // Adds an empty object as a new row
  };

  const fetchFieldInfo = async (headerConfigId, setFieldsFunc, setColumnDefsFunc) => {
    const payload = { headerconfig_id: headerConfigId,filterconditions: filterconditions };
  
    try {
      const FileUploadCredentials = Fetchheaderdata();
      const response = await axios.post(
        FileUploadCredentials[1], 
        payload, 
        FileUploadCredentials[0]
      );
  
      const data = response.data;
      console.log("fetched data",data)

      if (data.fields?.length) {
        const columns = data.fields.map((field) => ({
          headerName: formatColumnName(field.columnName),
          field: field.columnName,
        }));
        columns.push({
          headerName: "Edit",
          field: "edit",
          cellRendererFramework: (params) => (
            <Icon
              name="edit"
              style={{ cursor: 'pointer' }}
              onClick={() => handleEditClick(params.data)}
            />
          ),
          width: 100,
        });
  
        setColumnDefsFunc(columns);
        setFieldsFunc(data.fields);
        console.log("updation completed")
        return { fields: data.fields };
      }
    } catch (error) {
      console.error(`Error fetching field info for headerConfigId ${headerConfigId}:`, error);
      setError("Error fetching fields data");
        return { fields: []};
    }
  };
    

  const formatColumnName = (name) =>
    name.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());


  const handleEditClick = (row) => {
    console.log("Editing row:", row, fields,fields1,fields2,fields3);
    setEditMode(true); // Set edit mode to true
    setUnMatchedHidden(true);
    setCreateHidden(false);
    setPrfno(row.prf_number);
    Fetchrequirementinfo1(row.prf_number);
    Fetchrequirementinfo2(row.prf_number);
    Fetchrequirementinfo3(row.prf_number);
  };

  const handleCreateClick = (row) => {
    setUnMatchedHidden(true);
    setCreateHidden(false);
  };

  const handleListClick = (row) => {
    setUnMatchedHidden(false);
    setCreateHidden(true);
  };


  const Fetchrequirementinfo1 = async (prfn) => {
    const payload = {
      query: `select * from pouat.purchase_requirement where prf_number = '${prfn}';`
    };
    console.log("payload---", payload);

    const FileUploadCredentials = Fetchexecutequery();
    console.log("FileUploadCredentials---", FileUploadCredentials[0]);

    try {
      // Fetch the PRF data
      const response = await axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0]);
      const data = response.data;
      console.log("Fetching prf details for edit", data);

      // Fetch fields info and set it
      const fetchResponse = await fetchFieldInfo(25, setFields, setColumnDefs);


      // Access the latest state of fields after it has been set
      const currentFields = fetchResponse?.fields || []; // Ensure fields are retrieved from the fetch response
      console.log("currentFields",currentFields,data)
      if (currentFields.length > 0) {
        const updatedFormData = currentFields.reduce((acc, field) => {
          const columnName = field.columnName;
          const fieldType = field.function;
          let value = data[0][columnName]; // Get the corresponding value for the column from the first data record


          // Handle Date Fields
          if (fieldType === "Date Field" && value) {
            const dateObj = new Date(value);
            if (!isNaN(dateObj.getTime())) {
              if (field.dateFormat === "day") {
                value = dateObj.toISOString().slice(0, 10); // YYYY-MM-DD
              }
            } else {
              console.warn(`Invalid date value for column: ${columnName}`);
              value = ""; // Default invalid date value
            }
          }

          if (columnName === "requirement_date" && value) {
            const dateObj = new Date(value);
            if (!isNaN(dateObj.getTime())) {
                value = dateObj.toISOString().slice(0, 10); // YYYY-MM-DD
             
            } else {
              console.warn(`Invalid date value for column: ${columnName}`);
              value = ""; // Default invalid date value
            }
          }

if (columnName === "requirement_total" && value) {
  if (Number.isFinite(value)) { // Check if value is a number
    if (Number.isInteger(value)) {
      value = value.toFixed(2); // Convert integer to decimal format with 2 decimal places
    }
    // If it's already a decimal, leave it as is
  } else {
    console.warn(`Invalid total value for column: ${columnName}`);
    value = ""; // Default invalid value
  }
}


          // Handle Dropdown Fields
          if (fieldType === "Dropdown" && value && Array.isArray(field.options)) {
            const selectedOption = field.options.find(option => option.value === value);
            value = selectedOption ? selectedOption.value : value; // Use the value or fallback to the original
          }

          // Update the accumulated object
          acc[columnName] = value;
          return acc;
        }, {});
	console.log("updatedFormData",updatedFormData)
        // Set the formData with the updated values

	const updatedFormData1 = updatedFormData
// Specify the columns to include
const columnsToInclude = ["po_file_name", "VendorFile_name","SupportFile_name"]; // Replace with actual column names

// Filter the updatedFormData to include only specified columns
const filteredFormData = columnsToInclude.reduce((acc, column) => {
  if (updatedFormData1.hasOwnProperty(column)) {
    acc[column] = updatedFormData1[column];
  }
  return acc;
}, {});
	console.log("filteredFormData",filteredFormData)


// Set the formData with the filtered values
setFormData_1(filteredFormData);
  columnsToInclude.forEach((column) => {
    if (updatedFormData.hasOwnProperty(column)) {
      delete updatedFormData[column];
    }
  });

        setFormData(updatedFormData);

      } else {
        console.error("Error: 'fields' array is null or empty.");
      }
    } catch (error) {
      console.error("Error in Fetchrequirementinfo1:", error);
    }
  };

  const Fetchrequirementinfo2 = async (prfn) => {
    const payload = {
      query: `select * from pouat.line_details where prf_number = '${prfn}' and is_active=1;`
    };
    console.log("payload---", payload);
  
    const FileUploadCredentials = Fetchexecutequery();
    console.log("FileUploadCredentials---", FileUploadCredentials[0]);
  
    try {
      // Fetch the PRF data
      const response = await axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0]);
      const data = response.data;
      console.log("Fetching line details for edit", data);
  
      // Fetch fields info and set it
      const fetchResponse = await fetchFieldInfo(22, setFields1, setColumnDefs1);
  
      // Access the latest state of fields after it has been set
      const currentFields = fetchResponse?.fields || []; // Ensure fields are retrieved from the fetch response
      console.log("currentFields", currentFields, data);
  
      if (currentFields.length > 0 && Array.isArray(data) && data.length > 0) {
        // Map each row in data to include an index and transform fields as needed
        const updatedSection2Rows = data.map((row, index) => {
          const transformedRow = currentFields.reduce((acc, field) => {
            const columnName = field.columnName;
            const fieldType = field.function;
            let value = row[columnName]; // Get the corresponding value for the column
  
            // Default value for null or undefined
            value = value ?? "";
  
            // Handle Date Fields
            if (fieldType === "Date Field" && value) {
              const dateObj = new Date(value);
              if (!isNaN(dateObj.getTime())) {
                if (field.dateFormat === "day") {
                  value = dateObj.toISOString().slice(0, 10); // YYYY-MM-DD
                }
              } else {
                console.warn(`Invalid date value for column: ${columnName}`);
                value = ""; // Default invalid date value
              }
            }
  
            // Handle Dropdown Fields
            if (fieldType === "Dropdown" && value && Array.isArray(field.options)) {
              const selectedOption = field.options.find(option => option.value === value);
              value = selectedOption ? selectedOption.value : value; // Use the value or fallback to the original
            }
  
            // Update the accumulated object
            acc[columnName] = value;
            return acc;
          }, {});
  
          // Add an index to the transformed row
          return { ...transformedRow, index };
        });
  
        // Set the section2Rows with the transformed rows
        setSection2Rows(updatedSection2Rows);
      } else {
        console.error("Error: 'fields' array is null or empty or no data found.");
      }
    } catch (error) {
      console.error("Error in Fetchrequirementinfo2:", error);
    }
  };
  
const handleFieldChange = (event) => {
  const { value } = event.target;
  setRemarksData(value);
};

  const Fetchrequirementinfo3 = async (prfn) => {
    try {
      // Step 1: Fetch Quotation Details
      const quotationPayload = {
        query: `SELECT * FROM pouat.quotation_details where prf_number = '${prfn}' and is_active=1;`
      };
      const quotationCredentials = Fetchexecutequery();
      const quotationResponse = await axios.post(
        quotationCredentials[1],
        quotationPayload,
        quotationCredentials[0]
      );
      const quotationData = quotationResponse.data;
  
      console.log("Fetching quotation details for edit:", quotationData);
  
      const fetchQuotationFields = await fetchFieldInfo(23, setFields2, setColumnDefs2);
      const quotationFields = fetchQuotationFields?.fields || [];
  
      if (!Array.isArray(quotationData) || quotationData.length === 0) {
        console.warn("No quotation details found.");
        return;
      }
  
      // Transform Quotation Data
      const quotations = quotationData.map((row, index) => {
        const transformedRow = quotationFields.reduce((acc, field) => {
          acc[field.columnName] = row[field.columnName] ?? ""; // Handle null or undefined
          return acc;
        }, {});
        return { ...transformedRow, index, id: index + 1, label: `Quotation ${index + 1}` };
      });
  
      console.log("Updated Quotations:", quotations);
  
      // Set Quotations State
  
      // Step 2: Fetch Line Details
      const lineDetailsPayload = {
        query: `SELECT * FROM pouat.quotation_line_details where prf_number = '${prfn}' and is_active=1;`
      };
      const lineDetailsCredentials = Fetchexecutequery();
      const lineDetailsResponse = await axios.post(
        lineDetailsCredentials[1],
        lineDetailsPayload,
        lineDetailsCredentials[0]
      );
      const lineDetailsData = lineDetailsResponse.data;
  
      console.log("Fetching quotation line details for edit:", lineDetailsData);
  
      const fetchLineFields = await fetchFieldInfo(17, setFields4, setColumnDefs4);
      const lineFields = fetchLineFields?.fields || [];
  
      if (!Array.isArray(lineDetailsData) || lineDetailsData.length === 0) {
        console.warn("No quotation line details found.");
        setQuotationinputData(quotations.map(() => [])); // Ensure structure exists even if no line details
        return;
      }
  
      // Transform and Group Line Details
      const updatedQuotationData = quotations.map(() => []); // Initialize nested structure
  
      lineDetailsData.forEach((row) => {
        const vendorName = row.vendor_name;
        const matchingQuotationIndex = quotations.findIndex(q => q.vendor_name === vendorName);
  
        if (matchingQuotationIndex !== -1) {
          // Transform line details row
          const transformedRow = lineFields.reduce((acc, field) => {
            acc[field.columnName] = row[field.columnName] ?? ""; // Default null or undefined to empty string
            return acc;
          }, {});
  
          // Push to the correct quotation index
          updatedQuotationData[matchingQuotationIndex].push(transformedRow);
        } else {
          console.warn(`No matching quotation found for vendor: ${vendorName}`);
        }
      });
  
      // Update State with Nested Structure
      setQuotations(quotations);
      setFormData2(quotations[0] || {});
      setQuotationData(quotations);
      setQuotationinputData(updatedQuotationData);
      setSection3Rows(updatedQuotationData[0] || [{}]); // Default to the first quotation
      console.log("Nested Quotation Input Data:", updatedQuotationData);
    } catch (error) {
      console.error("Error fetching quotation and line details:", error);
    }
  };
  
  
  const Fetchrequirementinfo4 = async (prfn) => {
    const payload = {
      query: `SELECT * FROM pouat.quotation_line_details where prf_number = '${prfn}' and is_active=1;`
    };
    console.log("payload---", payload);
  
    const FileUploadCredentials = Fetchexecutequery();
    console.log("FileUploadCredentials---", FileUploadCredentials[0]);
  
    try {
      // Fetch the PRF data
      const response = await axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0]);
      const data = response.data;
      console.log("Fetching quotation details for edit", data);
  
      // Fetch fields info and set it
      const fetchResponse = await fetchFieldInfo(6, setFields3, setColumnDefs3);;

  
      // Access the latest state of fields after it has been set
      const currentFields = fetchResponse?.fields || []; // Ensure fields are retrieved from the fetch response
      console.log("currentFields", currentFields, data);
  
      if (currentFields.length > 0 && Array.isArray(data) && data.length > 0) {
        // Map each row in data to include an index and transform fields as needed
        const updatedQuotations = data.map((row, index) => {
          const transformedRow = currentFields.reduce((acc, field) => {
            const columnName = field.columnName;
            const fieldType = field.function;
            let value = row[columnName]; // Get the corresponding value for the column
  
            // Default value for null or undefined
            value = value ?? "";
  
            // Handle Date Fields
            if (fieldType === "Date Field" && value) {
              const dateObj = new Date(value);
              if (!isNaN(dateObj.getTime())) {
                if (field.dateFormat === "day") {
                  value = dateObj.toISOString().slice(0, 10); // YYYY-MM-DD
                }
              } else {
                console.warn(`Invalid date value for column: ${columnName}`);
                value = ""; // Default invalid date value
              }
            }
  
            // Handle Dropdown Fields
            if (fieldType === "Dropdown" && value && Array.isArray(field.options)) {
              const selectedOption = field.options.find(option => option.value === value);
              value = selectedOption ? selectedOption.value : value; // Use the value or fallback to the original
            }
  
            // Update the accumulated object
            acc[columnName] = value;
            return acc;
          }, {});
  
          // Add an index to the transformed row
          return { ...transformedRow, index, id: index + 1, label: `Quotation ${index + 1}` };
        });

        console.log("updatedQuotations",updatedQuotations)
  
        // Update the quotations and formData2 states

          setQuotationinputData(updatedQuotations); // Initialize inputs for all quotations

      } else {
        console.error("Error: 'fields' array is null or empty or no data found.");
      }
    } catch (error) {
      console.error("Error in Fetchrequirementinfo3:", error);
    }
  };

  const deleteRowInSection2 = (index) => {
    if (section2Rows.length > 1) {
      const updatedRows = section2Rows.filter((_, rowIndex) => rowIndex !== index);
      setSection2Rows(updatedRows);
    }
  };

  const deleteRowInSection3 = (index) => {
    if (section3Rows.length > 1) {
      const updatedRows = section3Rows.filter((_, rowIndex) => rowIndex !== index);
      setSection3Rows(updatedRows);
    }
  };


  async function handleCreate() {
    try {
      await handleCreate1(); // Ensure handleCreate1 finishes before moving on
      // await handleCreate2(); // Wait for handleCreate2
      // await handleCreate3(); // Wait for handleCreate3
      // await handleCreate4(); // Wait for handleCreate4
      // handleUpdate();
      // handleUpdate1();
      // handleUpdate2();
      // handleUpdate3();
      console.log("All create operations completed successfully");
    } catch (error) {
      console.error("Error during create operations:", error);
      setError("Error during create operations");
    }
  }




  const handleCreate1 = async () => {
    try {

      const formattedDate = getFormattedDate();
      
      // Combine form data with additional fields
      const updatedFormData = {
        ...formData,
        ...formData3,
        created_date: formattedDate,
        modified_date: formattedDate,
        tenant_id: userCredentials.tenants_id,
        entity_id: userCredentials.entities_id,
        group_id: userCredentials.groups_id,
        created_by: userCredentials.user_id,
        user_name: userCredentials.user_name,
        prf_number: prfno
      };
  
      // Create the payload
      const payload = createPayload('pouat', 'purchase_requirement', updatedFormData);
  
      // Get the file upload credentials
      const FileUploadCredentials = CreateData();
  
      // Make the API request
      await makeApiRequest(FileUploadCredentials[1], payload, FileUploadCredentials[0]);
    } catch (error) {
      console.error("Error in handleCreate1:", error.message);
      setError("Error creating data");
    }
  };
  

  const handleCreate2 = async () => {
    try {
    const formattedDate = getFormattedDate();
  
    const commonFields = {
      created_date: formattedDate,
      modified_date: formattedDate,
      tenant_id: userCredentials.tenants_id,
      entity_id: userCredentials.entities_id,
      group_id: userCredentials.groups_id,
      created_by: userCredentials.user_id,
      uploaded_by: userCredentials.user_name,
      prf_number: prfno,
    };
  
    const updatedFormData = enhanceRowsWithCommonFields(section2Rows, commonFields);
  
    const payload = createPayload("pouat", "line_details", updatedFormData);
    const FileUploadCredentials = CreateData();
  
    await makeApiRequest(FileUploadCredentials[1], payload, FileUploadCredentials[0]);
  } catch (error) {
    console.error("Error in handleCreate2:", error.message);
    setError("Error creating data");
  }
  };

  const handleCreate3 = async () => {
    try {
      console.log("Quotations Data:", quotationData, formData2);
  
      // Get formatted current date
      const formattedDate = getFormattedDate();
  
      // Define common fields to be added to each row
      const commonFields = {
        created_date: formattedDate,
        modified_date: formattedDate,
        tenant_id: userCredentials.tenants_id,
        entity_id: userCredentials.entities_id,
        group_id: userCredentials.groups_id,
        created_by: userCredentials.user_id,
        modified_by: userCredentials.user_id,
        uploaded_by: userCredentials.user_name,
        prf_number: prfno,
      };
  
      // Enhance rows with common fields
      const updatedFormData = enhanceRowsWithCommonFields(
        Object.values(quotationData), // Convert object to array of rows
        commonFields
      );
  
      // Create the payload
      const payload = createPayload('pouat', 'quotation_details', updatedFormData);
  
      // Get the file upload credentials
      const FileUploadCredentials = CreateData();
  
      // Make the API request
      await makeApiRequest(FileUploadCredentials[1], payload, FileUploadCredentials[0]);
    } catch (error) {
      console.error("Error in handleCreate3:", error.message);
      setError("Error creating data");
    }
  };
  

  const handleCreate4 = async () => {
    console.log("quotations", quotationData, quotationinputData, section3Rows, formData2);

    const currentDate = new Date();

    // Format the date to 'YYYY-MM-DD HH:mm:ss' compatible with MySQL
    const formattedDate = currentDate.toISOString().slice(0, 19).replace("T", " ");
    console.log("formattedDate ", formattedDate);

    const updatedFormData = [];

    // Iterate through quotationInputData array
    quotationinputData.forEach((inputGroup, index) => {
      const vendor = quotationData[index] ? quotationData[index].vendor_name : null;

      inputGroup.forEach((item) => {
        if (item) {
          updatedFormData.push({
            ...item,
            vendor_name: vendor, // Add the vendor name based on index
            created_date: formattedDate,
            modified_date: formattedDate,
            tenant_id: userCredentials.tenants_id,
            entity_id: userCredentials.entities_id,
            group_id: userCredentials.groups_id,
            created_by: userCredentials.user_id,
            modified_by: userCredentials.user_id,
            uploaded_by: userCredentials.user_name,
            prf_number: prfno
          });
        }
      });
    });

    const payload = {
      database: 'pouat',
      table: 'quotation_line_details',
      formData: updatedFormData, // Pass as an array
    };

    const FileUploadCredentials = CreateData();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then((response) => {
        console.log("Create response:", response);
      })
      .catch((error) => {
        console.error("Error creating data:", error);
        setError("Error creating data");
      });
  };

  const handleUpdate1 = () => {
    const payload = {
      schema_name: 'pouat',
      table: 'line_details',
      set_column : [{'purchase_requirement_id_int' : `(SELECT id FROM pouat.purchase_requirement WHERE prf_number = "${prfno}" LIMIT 1)`}],
      'where' : [{prf_number : `${prfno}`}]
    };

    const FileUploadCredentials = Fetchupdatequery();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Update response:", response);
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setError("Error updating data");
      });
  };

  const handleUpdate2 = () => {
    const payload = {
      schema_name: 'pouat',
      table: 'quotation_details',
      set_column : [{'purchase_requirement_id_int' : `(SELECT id FROM pouat.purchase_requirement WHERE prf_number = "${prfno}" LIMIT 1)`}],
      'where' : [{prf_number : `${prfno}`}]
    };

    const FileUploadCredentials = Fetchupdatequery();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Update response:", response);
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setError("Error updating data");
      });
  };

  const handleUpdate3 = () => {
    const payload = {
      schema_name: 'pouat',
      table: 'quotation_line_details',
      set_column : [{'purchase_requirement_id_int' : `(SELECT id FROM pouat.purchase_requirement WHERE prf_number = "${prfno}" LIMIT 1)`},
		    {'quotation_details_id_int' : `(SELECT id FROM pouat.quotation_details WHERE vendor_name = pouat.w_details.vendor_name and prf_number = "${prfno}" and entity_id =1 and is_active=1 group by vendor_name,entity_id,vendor_code LIMIT 1)`}],
      'where' : [{prf_number : `${prfno}`}]
    };

    const FileUploadCredentials = Fetchupdatequery();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Update response:", response);
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setError("Error updating data");
      });
  };

  const handleUpdate = () => {

    const payload = {
      schema_name: 'pouat',
      table: 'unique_number',
      set_column : [{'value_nocomma' : "value+1"}],
      'where' : [{"\`key\`" : 'uniqueNumber' ,entity_id : 1}]
    };


    const FileUploadCredentials = Fetchupdatequery();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Update response:", response);
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setError("Error updating data");
      });
  };


  const addQuotation1 = () => {
    setQuotations((prevQuotations) => [
      ...prevQuotations,
      { id: prevQuotations.length + 1, label: `Quotation ${prevQuotations.length + 1}` }
    ]);
    setFormData2({});
    setSection3Rows([{}]);
  };

  const addQuotation = () => {
    console.log("quotations addition",quotations)
    setQuotations((prevQuotations) => {
      const newId = prevQuotations.length; // Get the next id
      const newId1 = prevQuotations.length +1; // Get the next id
      console.log("addquotationid",newId)
      const newQuotations = [
        ...prevQuotations,
        { id: newId1, label: `Quotation ${newId1}` }
      ];
      setSelectedQuotation(newId); // Set the new quotation as selected
      setFormData2({}); // Reset form data for the new quotation
      setSection3Rows([{}]); // Reset section rows
      return newQuotations;
    });
  };


 const fetchprfTableInfo1 = async () => {
    const payload = { headerconfig_id: 21,filterconditions: filterconditions };

    try {
      const FileUploadCredentials = Fetchheaderdata();
      const response = await axios.post(
        FileUploadCredentials[1], // URL
        payload,                  // Payload
        FileUploadCredentials[0]   // Headers or Credentials
      );

      const data = response.data;
      let id = 0;
      if (data.fields && data.fields.length > 0) {
        const columns = data.fields.map((field) => ({
          headerName: formatColumnName(field.columnName),
          field: field.columnName,
        sortable: true,
        filter: true,
          resizable: true,
          width: 160

        }));
        columns.push({
          headerName: "Edit",
          field: "edit",
          cellRendererFramework: (params) => (
            <Icon
              name="edit"
              style={{ cursor: 'pointer' }}
              onClick={() => handleEditClick(params.data)}
            />
          ),
          width: 80, // Set width for the edit column
        });

console.log("Table Column Definitions:", columns);


        settableColumnDefs(columns);
      }
    } catch (error) {
      console.error("Error fetching field info:", error);
      setError("Error fetching fields data");
    }
    setLoading(false);
  };

  const onFilterTextChange = (event) => {
    const { value } = event.target;
    setSearchText(value);
  };

  const fetchtabledetailsInfo = async () => {
    const payload = { query: `SELECT prf_number,date(requirement_date) as requirement_date,po_file_name,department,purpose,purchase_category,po_status,
      p2p_approved_comments,dept_head_approved_comments,finance_approved_comments FROM pouat.purchase_requirement where is_active = 1 and (is_p2p_approved = 3 or is_dept_head_approved = 0) and entity_id = '${userCredentials["entities_id"]}' and approver_mailid = '${userCredentials["user_email"]}' order by id desc;` };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data && data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
        }));
	console.log("Table Row Data:", data);

        settableRowData(data);
      } else if (data && data.length === 0) {
        settableRowData([]);
      }

    } catch (error) {
      console.error("Error fetching department data:", error);
      setError("Error fetching department data");
    }
  };


  const handleInputChange = (name, value) => {
    console.log("formdata",formData)
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleInputChange3_1 = (name, value, index) => {
    setSection3Rows(prevRows => {
      const updatedRows = [...prevRows];
      updatedRows[index] = {
        ...updatedRows[index],
        [name]: value,
      };
      return updatedRows;
    });
  };

  const validateField = (value, type) => {
      if (!type) return true; // If no type is defined, skip validation

      switch (type.value) {
          case "text":
              return true; // Allow any text input
          case "integer":
              return /^-?\d*$/.test(value); // Allow integers (positive or negative) and empty input for partial typing
          case "decimal":
              return /^-?\d*\.?\d*$/.test(value); // Allow numbers with optional decimal points
          case "date":
              return !isNaN(Date.parse(value)); // Validate as a valid date
          default:
              return true; // For unsupported types, skip validation
      }
  };


  const handleInputChange1 = (name, value, index,type) => {
    console.log("section2rows",section2Rows)
    setSection2Rows(prevRows => {
      const updatedRows = [...prevRows];
      const isValid = validateField(value, type);
      if (!isValid) {
        console.warn(`Invalid input for ${type?.label}: ${value}`);
        return prevRows; // If invalid, do not update the state
      }
      // Update the field with the new value
      updatedRows[index] = {
        ...updatedRows[index],
        [name]: value,
      };
      // If the updated field is 'quantity' or 'unit_value', recalculate 'total_value'
      if (name === "quantity" || name === "unit_value") {
        const updatedRow = updatedRows[index];
        const totalValue = updatedRow.quantity * updatedRow.unit_value;
        // Update the total_value in the row
        updatedRows[index] = {
          ...updatedRow,
          total_value: totalValue,  // Recalculate total_value
        };
      }
      // Return the updated rows after modifying the necessary fields
      return updatedRows;
    });
  };



  const handlequotatationInputChange3 = (name, value, index,type) => {
    // First, update section3Rows
    console.log(section3Rows,index,quotationinputData)
    setSection3Rows(prevRows => {
      const updatedRows = [...prevRows];
      if (!Number.isInteger(index) || index < 0 || index >= updatedRows.length) {
        console.warn(`Invalid row index: ${index}. Defaulting to 0.`);
        index = 0; // Default index to 0 if invalid
      }

      const isValid = validateField(value, type);
      if (!isValid) {
        console.warn(`Invalid input for ${type?.label}: ${value}`);
        return prevRows; // If invalid, do not update the state
      }
      updatedRows[index] = {
        ...updatedRows[index],
        [name]: value,
      };
      // If the 'quantity' or 'unit_value' changed, recalculate total_value
      if (name === "quantity" || name === "unit_value") {
        const updatedRow = updatedRows[index];
        const totalValue = updatedRow.quantity * updatedRow.unit_value;
        // Update the total_value in the row
        updatedRows[index] = {
          ...updatedRow,
          total_value: totalValue,  // Recalculate total_value
        };
      }
      return updatedRows;
    });
    // Then, update quotationinputData
    setQuotationinputData(prevQuotationData => {
      const updatedQuotationData = [...prevQuotationData];

      // Initialize section3Rows for the selectedQuotationId if it doesn't exist
      if (!updatedQuotationData[selectedQuotationId]) {
        updatedQuotationData[selectedQuotationId] = [];
      }

      // Ensure the row exists in quotationData for the current index
      if (!updatedQuotationData[selectedQuotationId][index]) {
        updatedQuotationData[selectedQuotationId][index] = {};
      }


      // Update the specific field in quotationData
      updatedQuotationData[selectedQuotationId][index][name] = value;

      // If the 'quantity' or 'unit_value' changed, recalculate total_value
      if (name === "quantity" || name === "unit_value") {
        const updatedRow = updatedQuotationData[selectedQuotationId][index];
        const totalValue = updatedRow.quantity * updatedRow.unit_value;

        // Update the total_value in the row for quotationData
        updatedQuotationData[selectedQuotationId][index] = {
          ...updatedRow,
          total_value: totalValue,  // Recalculate total_value
        };
      }

      return updatedQuotationData;
    });
  };


  const handleQuotationChange = (name, value) => {
    setFormData2((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    // Update quotationData with the current quotation's edited data
    setQuotationData((prevData) => ({
      ...prevData,
      [selectedQuotationId]: {
        ...prevData[selectedQuotationId],
        [name]: value,
      },
    }));
    console.log("Updated field:",quotations, name, "with value:", value,quotationinputData);
  };

  const handleInputChange3 = (name, value) => {
    setFormData3((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleApprove1 = () => {

    const formattedDate = getFormattedDate();
    const payload = {
      schema_name: 'pouat',
      table: 'purchase_requirement',
      set_column : [{'is_dept_head_approved' : 1},{'is_p2p_approved' : 0},{'modified_by': userCredentials.user_id},{'modified_date': formattedDate},{'po_status': 'SENT TO P2P TEAM'},{'dept_head_approved_date': formattedDate },{'dept_head_approved_comments': remarksData}],
      'where' : [{prf_number : `${prfno}`}]
    };

    const FileUploadCredentials = Fetchupdatequery();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Update response:", response);
    setUnMatchedHidden(false);
    fetchtabledetailsInfo();
    setCreateHidden(true);
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setError("Error updating data");
      });
  };
const handleApprove = async () => {
  try {
    const formattedDate = getFormattedDate();
    const payload = {
      schema_name: 'pouat',
      table: 'purchase_requirement',
      set_column : [{'is_dept_head_approved' : 1},{'is_p2p_approved' : 0},{'modified_by': userCredentials.user_id},{'modified_date': formattedDate},{'po_status': 'SENT TO P2P TEAM'},{'dept_head_approved_date': formattedDate },{'dept_head_approved_comments': remarksData}],
      'where' : [{prf_number : `${prfno}`}]
    };

    const [config, url] = Fetchupdatequery();

    const response = await axios.post(url, payload, config);
    console.log("Update response:", response);

    await fetchtabledetailsInfo();
    console.log("Update response123:", response);
    setUnMatchedHidden(false);
    setCreateHidden(true);
  } catch (error) {
    console.error("Error updating data:", error);
    setError("Error updating data");
    // Optional: Display user-friendly notification
  }
};

  const handleReject = () => {

    const formattedDate = getFormattedDate();
    const payload = {
      schema_name: 'pouat',
      table: 'purchase_requirement',
      set_column : [{'is_dept_head_approved' : 2},{'modified_by':userCredentials.user_id},{'modified_date': formattedDate},{'po_status': 'Rejected by Department Head'},{'dept_head_approved_date': formattedDate },{'dept_head_approved_comments': remarksData}],
      'where' : [{prf_number : `${prfno}`}]
    };

    const FileUploadCredentials = Fetchupdatequery();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Update response:", response);
    setUnMatchedHidden(false);
    setCreateHidden(true);
    fetchtabledetailsInfo();

      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setError("Error updating data");
      });
  };

  const handleHold = () => {
    const formattedDate = getFormattedDate();
    const payload = {
      schema_name: 'pouat',
      table: 'purchase_requirement',
      set_column : [{'is_dept_head_approved' : 3},{'modified_by':userCredentials.user_id},{'modified_date': formattedDate},{'po_status': 'Hold by Department Head'},{'dept_head_approved_date': formattedDate },{'dept_head_approved_comments': remarksData}],
      'where' : [{prf_number : `${prfno}`}]
    };

    const FileUploadCredentials = Fetchupdatequery();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Update response:", response);
    setUnMatchedHidden(false);
    setCreateHidden(true);
    fetchtabledetailsInfo();

      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setError("Error updating data");
      });
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    if (editMode) {
      handleUpdate();
    } else {
      handleCreate();
    }
  };

  // Toggle div visibility
  const toggleDiv1 = () => setIsDiv1Open(!isDiv1Open);
  const toggleDiv2 = () => setIsDiv2Open(!isDiv2Open);
  const toggleDiv3 = () => setIsDiv3Open(!isDiv3Open);
  const toggleDiv4 = () => setIsDiv4Open(!isDiv4Open);

  if (loading) return <LoaderComponent />;

  return (
    <div>
      <h2 className="pt-1 pb-1 text-center" style={{ color: "#0a2352", fontSize: '18px' }}>
        PURCHASE REQUIREMENT
      </h2>
        <div hidden={unMatchedHidden}>
          <div>
          <div className="container-fluid d-flex justify-content-end align-items-center">
            <input
              className="search-input"
              type="text"
              placeholder="Search..."
              value={searchText}
              onChange={onFilterTextChange}
              style={{
                width: '30%',
                backgroundColor: 'white',
                marginRight: '8px',
                marginTop: '0',
                padding: '8px',
                borderRadius: '4px',
                border: '1px solid #ced4da',
              }}
            />

          </div>

          </div>
    {(!tablecolumnDefs.length && !tablerowData.length) ? (
      <div>Loading or no data available</div>
    ) : (
                <div
            className="ag-theme-alpine"
            style={{
              overflowX: 'auto',
              overflowY: 'auto',
              borderRadius: '10px',
              width: `${7.9* 200}px`,
              maxWidth: '100%',
              height : '700px',
              margin : '10px'
            }}
          >
            <AgGridReact
              columnDefs={tablecolumnDefs}
              rowData={tablerowData}
              style={{ width: '100%' }}
              quickFilterText={searchText}
              animateRows={true}
              pagination={true}
              paginationPageSize={15}

            />
      </div>
    )}

        </div>

      <div  hidden={createHidden}>
<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between",padding:'10px' }}>
  <div style={{ display: "flex" }}>
    <div className="prf-container" style={{ marginRight: "20px" }}>
      <span className="prf-label">PRF No:</span>
      <input
        type="text"
        value={prfno}
        readOnly
        className="prf-input"
        style={{ marginLeft: "10px" }}
      />
    </div>
  </div>

  <div
    onClick={handleListClick}
    style={{
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "50%",
      padding: "6px",
      backgroundColor: "#000055",
      transition: "background-color 0.3s",
      width: "40px",
      height: "40px",
    }}
    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#218838")}
    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#28a745")}
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 5H21M3 12H21M3 19H21"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
</div>

      {error && <div style={{ color: "red" }}>{error}</div>}

      {/* First collapsible section */}
      <div style = {{margin:"10px"}}>
        <h3 onClick={toggleDiv1} style={{ cursor: "pointer", color: "#4969ab",paddingLeft:'20px' }}>
          Requirement Header {isDiv1Open ? '-' : '+'}
        </h3>
        {isDiv1Open && (
<>
          <DynamicForm fields={fields} formData={formData} onInputChange={handleInputChange} onSubmit={handleSubmit} />
<div className="form-group-horizontal" style={{ display: "flex", alignItems: "center", gap: "20px" }}>
</div>
</>
        )}
      </div>
      {/* Second collapsible section */}
      <div style = {{margin:"10px"}}>
        <h3 onClick={toggleDiv2} style={{ cursor: "pointer", color: "#4969ab",paddingLeft:'20px' }}>
          Requirement Info {isDiv2Open ? '-' : '+'}
        </h3>
      <div style={{marginLeft: "20px",marginRight: "20px",backgroundColor: 'white',borderRadius: '8px'}}>
        {isDiv2Open && (
          <div>
            {/* Render rows dynamically with input fields */}
            {section2Rows && section2Rows.length > 0 ? (
              section2Rows.map((row, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    margin: "20px",
                    backgroundColor: 'white',
                    borderRadius: '8px',
                  }}
                >
                  {/* Render each field in the row */}
                  {fields1.map((field, fieldIndex) => (
  <div key={fieldIndex} className="form-group">
    <label className="form-label" style={{ marginLeft: "5px" }}>
      {formatColumnName(field.columnName)}:
    </label>
    <div className="data-displayer-box1" style={{ marginLeft: "10px" }}>
      {field.columnName === "budget_category" ? (
        <span>
          {row[field.columnName] || "N/A"} {/* Display the value or "N/A" if no value */}
        </span>
      ) : (
        <span>
          {row[field.columnName] || "N/A"} {/* Display the value or "N/A" if no value */}
        </span>
      )}
    </div>
  </div>
))}
                </div>
              ))
            ) : (
              <p>No rows available</p>
            )}
          </div>
        )}
      </div>
      </div>
      {/* Third collapsible section */}
      <div style = {{margin:"10px"}}>
        <h3 onClick={toggleDiv3} style={{ cursor: "pointer", color: "#4969ab",paddingLeft:'20px' }}>
          Quotation Info {isDiv3Open ? '-' : '+'}
        </h3>
{isDiv3Open && (
  <div>
    {/* Tab-like navigation for quotations */}
    <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap",paddingLeft:'20px' }}>
      {quotations.map((quotation, index) => (
        <button
          key={quotation.id}
          onClick={() => setSelectedQuotation(index)}
          style={{
            padding: "10px 20px",
            cursor: "pointer",
            border: "none",
            backgroundColor: selectedQuotationId === index ? "#000055" : "white",
            color: selectedQuotationId === index ? "white" : "black", // Corrected 'fontColor' to 'color'
            fontWeight: selectedQuotationId === index ? "bold" : "normal"
          }}
        >
          {quotation.label}
        </button>
      ))}
    </div>

    {/* Render the selected quotation's form */}
    {quotations.map((quotation, index) => (
      selectedQuotationId === index && (
        <div key={`form-${quotation.id}`} style={{ marginTop: "20px" }}>
          <DynamicForm
            fields={fields2}
            formData={formData2}
            onInputChange={handleQuotationChange}
            onSubmit={handleSubmit}
          />

          {/* Section to render rows with dynamic add and delete functionality */}
          {section3Rows && section3Rows.length > 0 ? (
            section3Rows.map((row, rowIndex) => (
              <div
                key={rowIndex}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  margin: "20px",
                  backgroundColor: 'white',
                  borderRadius: '8px',
                  padding: '10px'
                }}
              >
{fields4 .map((field, fieldIndex) => (
  <div key={fieldIndex} className="form-group">
    <label className="form-label" style={{ marginLeft: "5px" }}>
      {formatColumnName(field.columnName)}:
    </label>
    <div className="data-displayer-box1" style={{ marginLeft: "10px" }}>
      {field.columnName === "budget_category" ? (
        <span>
          {row[field.columnName] || "N/A"} {/* Display the value or "N/A" if no value */}
        </span>
      ) : (
        <span>
          {row[field.columnName] || "N/A"} {/* Display the value or "N/A" if no value */}
        </span>
      )}
    </div>
  </div>
))}
              </div>
            ))
          ) : (
            <p>No rows available</p>
          )}

        </div>
      )
    ))}
  </div>
)}

<div style={{ display: "flex", gap: "1rem", alignItems: "center",margin : '20px' }}>
  <div className="form-group" style={{ width: "670px" }}>
    <label className="form-label" htmlFor="remarks" style={{ marginBottom: "0.5rem", display: "block" }}>
      Remarks:
    </label>
    <textarea
      id="remarks"
      name="remarks"
      style={{
        resize: "none",
        overflow: "hidden",
        width: "660px",
        minHeight: "80px",
        padding: "0.5rem",
        border: "1px solid #ccc",
        borderRadius: "4px",
        color: "black",
      }}
      value={remarksData}
      placeholder="Enter remarks here..."
      onChange={(e) => handleFieldChange(e)}
    ></textarea>
  </div>

  <div style={{ display: "flex", flexDirection: "row", gap: "0.5rem" }}>
    <button type="submit" className="submit-btn" style ={{ width :'90px'}} onClick={handleApprove} >
      Approve
    </button>
    <button type="submit" className="submit-btn" style ={{ width :'90px'}} onClick={handleHold}>
      Hold
    </button>
    <button type="submit" className="submit-btn" style ={{ width :'90px'}} onClick={handleReject}>
      Reject
    </button>
  </div>
  </div>
</div>
    </div>
    </div>
  );
}

export default PurchaseRequirement;